import { useState } from 'react';
import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Bars3Icon, BellIcon } from '@heroicons/react/24/outline';
import { MobileBottomBar } from './MobileBottomBar';
import { MobileMenuDrawer } from './MobileMenuDrawer';
import { useAuthStore } from '../../stores/authStore';
import { FinLabLogo } from '../../shared/components/FinLabLogo';

export function MobileNav() {
  const { t } = useTranslation();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const { user } = useAuthStore();

  return (
    <>
      {/* Mobile Top Bar */}
      <header className="fixed top-0 left-0 right-0 z-40 bg-white border-b border-gray-200 md:hidden safe-area-top">
        <div className="flex items-center justify-between h-16 px-4">
          {/* Logo */}
          <Link to="/dashboard" className="flex items-center">
            <FinLabLogo variant="light" size="sm" />
          </Link>

          {/* Right Actions */}
          <div className="flex items-center space-x-2">
            {/* Notifications */}
            <button
              className="p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors active:bg-gray-200"
              style={{ minHeight: '44px', minWidth: '44px' }}
            >
              <span className="sr-only">{t('nav.notifications')}</span>
              <BellIcon className="w-6 h-6" />
            </button>

            {/* User Avatar - Opens Drawer */}
            <button
              onClick={() => setIsDrawerOpen(true)}
              className="flex items-center space-x-2 p-1.5 rounded-lg hover:bg-gray-100 transition-colors active:bg-gray-200"
              style={{ minHeight: '44px', minWidth: '44px' }}
            >
              <div className="w-9 h-9 bg-brand-purple-600 rounded-full flex items-center justify-center shadow-sm">
                <span className="text-white font-semibold text-sm">
                  {user?.name?.charAt(0).toUpperCase() || 'U'}
                </span>
              </div>
            </button>

            {/* Hamburger Menu - Opens Drawer */}
            <button
              onClick={() => setIsDrawerOpen(true)}
              className="p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors active:bg-gray-200"
              style={{ minHeight: '44px', minWidth: '44px' }}
            >
              <span className="sr-only">{t('nav.openMenu')}</span>
              <Bars3Icon className="w-6 h-6" />
            </button>
          </div>
        </div>
      </header>

      {/* Bottom Navigation Bar */}
      <MobileBottomBar />

      {/* Menu Drawer */}
      <MobileMenuDrawer
        isOpen={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
      />
    </>
  );
}
